const planesSection = document.querySelector('.aircraft .planes-section')

const toggleLarge = document.querySelector('.toggles button.large')
const toggleSmall = document.querySelector('.toggles button.small')

const largePlanesGroup = planesSection.querySelector('.planes-group.large')
const smallPlanesGroup = planesSection.querySelector('.planes-group.small')

const largePlanes = largePlanesGroup.querySelectorAll('.plane')
const smallPlanes = smallPlanesGroup.querySelectorAll('.plane')

const dotsWrapper = planesSection.querySelector('.dots')
const dots = planesSection.querySelectorAll('.dots button')

function activatePlane(plane, group) {
	group.querySelector('.plane.active')?.classList.remove('active')
	plane.classList.add('active')

	planesSection.querySelector('[id^=route-].active')?.classList.remove('active')
	planesSection
		.querySelector(`#route-${plane.dataset.route}`)
		?.classList.add('active')
}

function activateDot(index) {
	for (let i = 0; i < dots.length; i++) {
		if (i == index) {
			dots[i].classList.add('active')
		} else {
			dots[i].classList.remove('active')
		}
	}
}

var largeSlider = new KeenSlider(
	'.aircraft .keen-slider.large',
	{
		breakpoints: {
			'(min-width: 512px)': {
				slides: {
					perView: 1.5,
					spacing: 24,
				},
			},
			'(min-width: 768px)': {
				slides: {
					perView: 2.5,
					spacing: 32,
				},
			},
			'(min-width: 992px)': {
				slides: {
					perView: 3,
					spacing: 32,
				},
			},
			'(min-width: 1280px)': {
				disabled: true,
			},
		},
		loop: true,
		slides: {
			perView: 1,
			spacing: 16,
		},
		defaultAnimation: {
			duration: 800,
		},
	},
	[
		largeSlider => {
			function updateClasses() {
				if (window.innerWidth < 1280) {
					activatePlane(
						largeSlider.slides[largeSlider.track.details.rel],
						largePlanesGroup
					)
					activateDot(largeSlider.track.details.rel)
				}
			}
			largeSlider.on('slideChanged', updateClasses)
		},
	]
)

var smallSlider = new KeenSlider(
	'.aircraft .keen-slider.small',
	{
		breakpoints: {
			'(min-width: 512px)': {
				slides: {
					perView: 1.5,
					spacing: 24,
				},
			},
			'(min-width: 768px)': {
				slides: {
					perView: 2.5,
					spacing: 32,
				},
			},
			'(min-width: 992px)': {
				slides: {
					perView: 3,
					spacing: 32,
				},
			},
			'(min-width: 1280px)': {
				disabled: true,
			},
		},
		loop: true,
		slides: {
			perView: 1,
			spacing: 16,
		},
		defaultAnimation: {
			duration: 800,
		},
	},
	[
		smallSlider => {
			function updateClasses() {
				if (window.innerWidth < 1280) {
					activatePlane(
						smallSlider.slides[smallSlider.track.details.rel],
						smallPlanesGroup
					)
					activateDot(smallSlider.track.details.rel)
				}
			}
			smallSlider.on('slideChanged', updateClasses)
		},
	]
)

largePlanes.forEach(plane => {
	plane.addEventListener('click', () => {
		activatePlane(plane, largePlanesGroup)
		largeSlider.moveToIdx(parseInt(plane.dataset.index))
		activateDot(plane.dataset.index)
	})
})

smallPlanes.forEach(plane => {
	plane.addEventListener('click', () => {
		activatePlane(plane, smallPlanesGroup)
		smallSlider.moveToIdx(parseInt(plane.dataset.index))
		activateDot(plane.dataset.index)
	})
})

toggleLarge.addEventListener('click', () => {
	planesSection.dataset.active = 'large'
	activatePlane(largePlanes[0], largePlanesGroup)
	activateDot(0)
	largeSlider.moveToIdx(0)
})

toggleSmall.addEventListener('click', () => {
	planesSection.dataset.active = 'small'
	activatePlane(smallPlanes[0], smallPlanesGroup)
	activateDot(0)
	smallSlider.moveToIdx(0)
})

for (let i = 0; i < dots.length; i++) {
	dots[i].addEventListener('click', () => {
		activateDot(i)
		activatePlane(largePlanes[i], largePlanesGroup)
		activatePlane(smallPlanes[i], smallPlanesGroup)
		largeSlider.moveToIdx(parseInt(i))
		smallSlider.moveToIdx(parseInt(i))
	})
}
